__webpack_require__.p = "https://speedup.straumann.com/";